
const main = () => {
    if (document.querySelector('#zip') === null) return;
    document.getElementById('zip').addEventListener('input', (e) => {
        let val = e.currentTarget.value;
        // 入力値からハイフンを除去して7桁の数字にする
        const cleanZip = val.replace(/-/g, '');

        // 7桁になった場合に処理を実行
        if (cleanZip.length === 7) {
            // ハイフン付き形式（xxx-xxxx）を作成
            const formattedZip = cleanZip.slice(0, 3) + '-' + cleanZip.slice(3);
            // 現在の入力が自動補完済みでなければ、更新する
            if (val !== formattedZip) {
                val = formattedZip;
            }

            // APIリクエストはハイフン除去済みの数字を利用
            fetch(`https://api.zipaddress.net/?zipcode=${cleanZip}`)
                .then(response => response.json())
                .then(data => {
                    if (data.code === 200) {
                        // 住所自動入力部分（address）にセット
                        const addressElement = document.getElementById('address');
                        addressElement.value = data.data.fullAddress;

                        // 次の入力欄（address2）にカーソルを移動
                        const address2Element = document.getElementById('address2');
                        address2Element.focus();
                        address2Element.setSelectionRange(
                            address2Element.value.length,
                            address2Element.value.length
                        );
                    } else {
                        alert('住所が見つかりませんでした。');
                    }
                })
                .catch(error => {
                    console.error('エラー:', error);
                    alert('住所の取得中にエラーが発生しました。');
                });
        }
    });
}

export default main;